import { MAIN_ENDPOINT } from "../../../config/api-client";

export const ENDPOINT = MAIN_ENDPOINT;
